export class EnableLocationTransactionalCommunicationInput {
  id: number;
  // data/hora local (America/Sao_Paulo) no formato YYYY-MM-DDTHH:mm:ss
  sinceDate: string;
}
